//* 상주만 보는 Router hased by MemberId

import { FC, useMemo } from 'react';

import { useRecoilValue } from 'recoil';

import CourtesyAccessGate from '@service/bugo/components/CourtesyAccessGate';
import CourtesyEditPage from '@service/bugo/page/CourtesyEditPage';
import CourtesySenderPage from '@service/bugo/page/CourtesySenderPage';
import CourtesySenderPreviewPage from '@service/bugo/page/CourtesySenderPreviewPage';
import MemberObituaryPage from '@service/bugo/page/MemberObituaryPage';
import { useBugoByMemberIdHook } from '@shared/api/bugo/bugo.hook';
import { bugoByMemberIdStateSelectorFamily } from '@shared/api/bugo/bugo.selector';
import _ from 'lodash';
import { Navigate, Route, Routes, useParams } from 'react-router-dom';

//* 답례글 3페이지는 상주 구매 퍼널(답례품 스토어 진입점)이라 청크 분리 없이 기본 번들에 둔다 (사유: @route/lazyRouters.ts 상단)
const BugoMemberIdRouter: FC = () => {
  const { memberId } = useParams();
  // 게이트가 같은 키의 atom을 읽어야 하므로 조회 키를 한 곳에서 만든다.
  const memberId_ = memberId ?? 'undefined';
  useBugoByMemberIdHook(memberId_);
  const bugoByMemberIdState = useRecoilValue(
    bugoByMemberIdStateSelectorFamily(memberId_),
  );

  const bugoTheme = useMemo(() => {
    if (bugoByMemberIdState.status === 'success' && bugoByMemberIdState.data) {
      const bugo = bugoByMemberIdState.data;
      const index = bugo.fevent.bugoBrandAgencyIndex;
      return !_.isNil(index) && bugo.bugoBrand?.bugoAgencyList
        ? bugo.bugoBrand.bugoAgencyList[index]?.theme
        : bugoByMemberIdState.data?.bugoBrand?.bugoAgency?.theme;
    }
  }, [bugoByMemberIdState.data, bugoByMemberIdState.status]);

  return (
    <div className={`max-w-inherit ${bugoTheme}`}>
      <Routes>
        //* 부고 공유 페이지(개인정보동의, 등록도 할 수 있음)
        <Route path="bugo" element={<MemberObituaryPage />} />
        //* 답례글 공유 페이지 (부고 없음 / 발인 후 60일 초과 시 안내 화면으로 대체)
        <Route path="courtesy" element={<CourtesyAccessGate memberId={memberId_} />}>
          <Route path="" element={<CourtesySenderPage />} />
          <Route path="preview" element={<CourtesySenderPreviewPage />} />

          <Route path="edit" element={<CourtesyEditPage />} />
        </Route>
        <Route path="*" element={<Navigate to="bugo"></Navigate>} />
      </Routes>
    </div>
  );
};

export default BugoMemberIdRouter;
